function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircleChevronRightFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 1.031a14.969 14.969 0 100 29.938A14.969 14.969 0 0016 1.03zm-2.868 22.453l-1.748-1.745L17.123 16l-5.74-5.739 1.749-1.745L20.616 16l-7.484 7.484z",
    fill: props.color
  }));
}

export default SvgIconArrowCircleChevronRightFilled;